module.exports = __webpack_public_path__ + "fonts/Roboto-MediumItalic.13ec0eb5.woff2";